import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedBudgetStepWithI18n =
  () => import(/* webpackChunkName: 'budget-step.async' */'./budget-step')
    .then(({ BudgetStepWithI18n }) => BudgetStepWithI18n);

const DelayedBudgetLazyRepository =
  () => import(/* webpackChunkName: 'budget-step.async' */'./budget-lazy-repository')
    .then(({ BudgetLazyRepositoryWithI18n }) => BudgetLazyRepositoryWithI18n);

export const BudgetStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.BUDGET,
  view: DelayedBudgetStepWithI18n,
  repository: DelayedBudgetLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
  viewProps: {
    showMessage: true,
    titleStyle: { fontSize: '26px', marginBottom: '16px' },
  },
};
